import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { Box, Grid,} from "@material-ui/core";
import OpSearchBar from "../components/OpSearchBar";
import OpTable from "../components/OpTable";
import { permissionCheckFnforCamo} from "../../../../utils";
import { OpTableHead } from "./OpTableHead";
import { AccessDenied, EmptyCollection, PageLoader,DeletePopUp } from "../../../../shared_elements";
import OpHistoryList from "../components/OpHistoryList";
import { deleteOpAssetDetailRow, fillOpEditFormApi, getOpHistoryApi, importOpFileApi, UpdateOpFormApi, uploadOpFileApi, exportOpListApi, DownloadAllApi, exportMasterApi,bulkDelete,onArchiveAsset } from "../apiServices";
import BasicDetailHeader from "../../BasicDetailHeader";
import { trackActivity } from "../../../../utils/mixpanel";
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails";
class OpHistoryComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addFormDialog: false,
            sidebarOpen: true,
            tabIndex: 0,
            pageLoader: false,
            sort: "",
            sort_by: "",
            assetsDetail: {
                list: [],
                pagination: {},
                asset_count: {},
                new_task_last_used_folder_uuid: '',
                last_used_folder_uuid_link_document: "",
                checkbox_last_used_folder_uuid: '',
                checkbox_last_used_folder_name: ''
            },
            headerData: {},
            headerTsn: "",
            headerCsn: "",
            currentRecordPerPage:250,
            uuid: "",
            slug: "",
            engineType: {},
            basicDetails: {},
            isBasicDetailExpanded: true,
            bulkOperation: { modal: false, ids: [], title: '', type: '' },
            archiveModal:false
        };
        this.getOpHistoryApi = getOpHistoryApi.bind(this);
        this.openAddForm = this.openAddForm.bind(this);
        this.closeAddForm = this.closeAddForm.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.handleDeleteRow = deleteOpAssetDetailRow.bind(this); //done
        this.handleEditRow = fillOpEditFormApi.bind(this);
        this.UpdateOpFormApi = UpdateOpFormApi.bind(this); //done
        this.uploadOpFileApi = uploadOpFileApi.bind(this); //done
        this.importOpFileApi = importOpFileApi.bind(this); //done
        this.downloadAllApi = DownloadAllApi.bind(this);
        this.exportOpListApi = exportOpListApi.bind(this);
        this.exportMasterApi = exportMasterApi.bind(this);
        this.bulkDelete = bulkDelete.bind(this);
        this.onArchiveAsset = onArchiveAsset.bind(this);
        
    }

    componentDidMount() {
        this.getData();
        this.pullData();
        trackActivity('OP History  Page Visited - CAMO', {
            event_type: 'Page Visited',
            page_title: 'OP History',
        })
    }
    pullData = (slug, tsn, csn,) => {
        this.setState({ slug: slug });
        this.setState({ headerTsn: tsn });
        this.setState({ headerCsn: csn });

    };
    uuidData = (uuid) => {
        this.setState({ uuid: uuid });
    }
    engineType = (engineType) => {
        this.setState({ engineType: engineType });
        this.setState({ basicDetails: engineType })
    }


    getData =  async(item, bulk) => {
         this.getOpHistoryApi({ per_page:this.state.currentRecordPerPage }, "skeletonLoader", this.props, item ? item : null);
    }
    openAddForm() {
        this.setState({ addFormDialog: true });
    }
    closeAddForm() {
        this.setState({ addFormDialog: false });
    }

    toggleSidebar() {
        this.setState({ sidebarOpen: !this.state.sidebarOpen });
    }
    createSortHandler = (sortField) => {
        const { sort, sort_by, filter, tabIndex, assetsDetail } = this.state;
        this.setState({
            sort: sortField,
            sort_by: sort_by === "asc" ? "desc" : "asc",
        })
        if (sort_by === "asc") {
            this.getOpHistoryApi({ ...filter, sort: sortField, sort_by: "desc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
        } else {
            this.getOpHistoryApi({ ...filter, sort: sortField, sort_by: "asc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
        }
    }
    searchResults = (item) => {
        if (item !== null) {
             this.getData(item);
        }
    };

    updateFormData = async (updateId, updatedData, props,close,formClose) => {
        await this.UpdateOpFormApi(updateId, updatedData, props, this.state.currentRecordPerPage,close,formClose);
    };

    fileUploadData = async (uploadId, formdata, props, haveAttachments) => {
        await this.uploadOpFileApi(uploadId, formdata, props, this.state.currentRecordPerPage, haveAttachments);
    };

    importFile = (formData, props, isXLSX) => {
        this.importOpFileApi(formData, props, isXLSX, this.state.currentRecordPerPage);
    };

    exportAssetDetailListFunc = (props) => {
        const { basicDetails } = this.state;
        this.exportOpListApi(props, '', this.props, basicDetails);
    };

    downloadAllFilesApi = (props) => {
        this.downloadAllApi(props);
    };

    refreshComp = () => {
        this.getData();
    };
    toggleBulkOps = async (flag, type, item) => {
        const { bulkOperation, assetsDetail } = this.state;   
        try {
            if (type === 'bulk') {
                const response = await this.getOpHistoryApi(
                    { per_page: assetsDetail?.pagination?.total},
                    "skeletonLoader",
                    this.props,
                    null
                );
                this.setState({
                    bulkOperation: { ...bulkOperation, type: 'bulk', ids: flag ? response?.data?.results : [] }
                });
            } else {
                this.setState({
                    bulkOperation: {
                        ...bulkOperation,
                        type: 'single',
                        ids: flag ? [...bulkOperation.ids, item] : bulkOperation.ids.filter(optionItem => optionItem.id !== item.id)
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
    
    render() {
        const { tabIndex, sort, sort_by, filter, assetsDetail, pageLoader, uuid, slug, basicDetails, bulkOperation, archiveModal, isBasicDetailExpanded } = this.state;

        return (
            <section className="amp-listing-section">
                {pageLoader ? <PageLoader /> : null}
                <Grid className="mt-0" spacing={3} container>
                    <Grid className="pt-0 pr-0" xs={12} item>
                        <SubDetails
                            masterExport={true}
                            title="Op. History"
                            slug={slug}
                            module='Op'
                            match={this.props?.match}
                            onRefresh={this.refreshComp}
                            permissionCheck={permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" })}
                        />
                        <BasicDetailHeader props={this.props} func={this.pullData} uuid={this.uuidData} module='Op' engineType={this.engineType} onAccordionChange={(expanded) => this.setState({ isBasicDetailExpanded: expanded })} />
                        {permissionCheckFnforCamo({
                            primaryKey: "ad_status",
                            keyIndex: "R",
                        }) ? (
                            <div className="custom-border">
                                <OpSearchBar
                                    currentRecordPerPage={this.state.currentRecordPerPage}
                                    tabIndex={tabIndex}
                                    pageLoader={"pageLoader"}
                                    props={this.props}
                                    uuid={uuid}
                                    importFile={this.importFile}
                                    getResponseBack={this.refreshComp}
                                    fileUploadData={this.fileUploadData}
                                    searchData={(e) => this.searchResults(e.target.value)}
                                    engineType={this.state.engineType}
                                    basicDetails={basicDetails}
                                    assetsDetail={assetsDetail?.list}
                                    exportReportFn={(file) =>
                                        this.exportAssetDetailListFunc(
                                            {
                                                download: file.extension,
                                                ...filter,
                                                ...(sort === "" && sort_by === "" ? {} : { sort, sort_by }),
                                            },
                                            "pageLoader"
                                        )
                                    }
                                />
                                <OpTable
                                    currentRecordPerPage={this.state.currentRecordPerPage}
                                    heads={OpTableHead}
                                    sort={sort}
                                    basicDetails={basicDetails}
                                    isBasicDetailExpanded={isBasicDetailExpanded}
                                    bulkDeletefn={()=>this.bulkDelete(this.props,bulkOperation, assetsDetail.pagination.per_page,)}
                                    bulkOperation={bulkOperation}
                                    bulkFlag={assetsDetail?.list?.length === bulkOperation?.ids?.length && assetsDetail?.list?.length > 0}
                                    toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'bulk')}
                                    sort_by={sort_by}
                                    data={assetsDetail?.list?.map((item, index) => (
                                        <OpHistoryList
                                            bulkOperation={bulkOperation}
                                            toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'single', item)}
                                            currentRecordPerPage={this.state.currentRecordPerPage}
                                            key={index}
                                            item={item}
                                            uuid={uuid}
                                            engineType={this.state.engineType}
                                            basicDetails={basicDetails}
                                            assetsDetail={assetsDetail?.list}
                                            getResponseBack={this.refreshComp}
                                            last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
                                            last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
                                            checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
                                            checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
                                            index={index}
                                            handleDeleteRow={(data) =>
                                                this.handleDeleteRow(
                                                    item,
                                                    this.props,
                                                    this.state.currentRecordPerPage
                                                )
                                            }
                                            updateFormData={this.updateFormData}
                                            handleEditRow={(data) =>
                                                this.handleEditRow(item, this.props)
                                            }
                                            props={this.props}
                                            fileUploadData={this.fileUploadData}
                                            downloadAllApi={(file) =>
                                                this.downloadAllFilesApi(
                                                    {
                                                        download: file.extension,
                                                        ...{
                                                            asset_type: tabIndex,
                                                            item,
                                                        },
                                                    },

                                                    "pageLoader"
                                                )
                                            }
                                        />
                                    ))}
                                    createSortHandler={this.createSortHandler}
                                    pagination={assetsDetail.pagination}
                                    onChangePage={(event, newPage) =>
                                        this.getOpHistoryApi({
                                            asset_type: this.state.tabIndex,
                                            per_page: assetsDetail.pagination.per_page,
                                            page: newPage + 1,
                                        },
                                            "pageLoader",
                                            this.props
                                        )
                                    }
                                    onChangeRowsPerPage={(event) =>
                                        this.setState(
                                            { currentRecordPerPage: event.target.value },
                                            () => {
                                                this.getOpHistoryApi({
                                                    asset_type: this.state.tabIndex,
                                                    per_page: this.state.currentRecordPerPage,

                                                },
                                                    "pageLoader",
                                                    this.props
                                                );
                                            }
                                        )
                                    }
                                    noRecord={
                                        assetsDetail?.list?.length ? null : !this.state.pageLoader ? (
                                            <EmptyCollection title="No Records Found" />
                                        ) : null
                                    }
                                />
                            </div>
                        ) : (
                            <AccessDenied />
                        )}
                    </Grid>
                </Grid>
                {
                    archiveModal ?
                        <DeletePopUp
                            title='Archive Asset'
                            deleteRecordFn={() => this.onArchiveAsset(this.props, slug)}
                            modal={() => this.setState({ archiveModal: true })}
                            content='Are you sure, you want to Archive?'
                            toggleModalFn={() => this.setState({ archiveModal: false })}
                            confirmText="ARCHIVE"
                        />
                        : null
                }
            </section>
        );
    }
}
export default withSnackbar(OpHistoryComponent);
